import { addToCart } from '@nova/utils'

function measureProductDescriptionExpandable(root) {
  const inner = root.querySelector('.js-product-description-inner')
  const content = root.querySelector('.product__description-content')
  const toggle = root.querySelector('.js-product-description-toggle')
  const label = root.querySelector('.js-product-description-toggle-label')

  if (!inner || !toggle || !label) return

  const collapsedHeight =
    Number.parseInt(
      getComputedStyle(root).getPropertyValue('--product-description-collapsed-height'),
      10,
    ) || 200

  inner.style.maxHeight = 'none'
  const fullHeight = Math.max(content?.scrollHeight ?? 0, inner.scrollHeight)
  const needsTruncate = fullHeight > collapsedHeight + 1

  root.dataset.descriptionFullHeight = String(fullHeight)
  root.dataset.descriptionCollapsedHeight = String(collapsedHeight)

  if (needsTruncate) {
    root.classList.remove('product__description-expandable--full')
    root.classList.add('product__description-expandable--truncated')
    toggle.hidden = false

    const expanded = root.classList.contains('is-expanded')
    inner.style.maxHeight = expanded ? `${fullHeight}px` : `${collapsedHeight}px`
    return
  }

  root.classList.add('product__description-expandable--full')
  root.classList.remove('product__description-expandable--truncated', 'is-expanded')
  toggle.hidden = true
  toggle.setAttribute('aria-expanded', 'false')
  label.textContent = root.dataset.showMore
  inner.style.maxHeight = 'none'
}

function bindProductDescriptionExpandable(root) {
  if (root.dataset.descriptionToggleBound === 'true') return
  root.dataset.descriptionToggleBound = 'true'

  const inner = root.querySelector('.js-product-description-inner')
  const toggle = root.querySelector('.js-product-description-toggle')
  const label = root.querySelector('.js-product-description-toggle-label')
  const content = root.querySelector('.product__description-content')

  if (!inner || !toggle || !label) return

  toggle.addEventListener('click', () => {
    if (root.classList.contains('product__description-expandable--full')) return

    const fullHeight = Number.parseInt(root.dataset.descriptionFullHeight, 10)
    const collapsedHeight = Number.parseInt(root.dataset.descriptionCollapsedHeight, 10)
    const expanded = root.classList.toggle('is-expanded')

    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false')
    label.textContent = expanded ? root.dataset.showLess : root.dataset.showMore
    inner.style.maxHeight = expanded ? `${fullHeight}px` : `${collapsedHeight}px`
  })

  if (root.dataset.descriptionResizeBound !== 'true') {
    root.dataset.descriptionResizeBound = 'true'

    const remeasure = () => measureProductDescriptionExpandable(root)

    if (content && typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(remeasure)
      observer.observe(content)
    }

    content?.querySelectorAll('img').forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', remeasure, { once: true })
      }
    })

    window.addEventListener('load', remeasure, { once: true })
  }
}

function initProductDescriptionExpandables(container = document) {
  const expandables = container.querySelectorAll('.js-product-description-expandable')

  for (const root of expandables) {
    bindProductDescriptionExpandable(root)
    measureProductDescriptionExpandable(root)
  }
}

document.addEventListener('shopify:section:load', (event) => {
  initProductDescriptionExpandables(event.target)
})

document.addEventListener('DOMContentLoaded', () => {
  initProductDescriptionExpandables()
  const $forms = Array.from(document.querySelectorAll('.js-product-form') || [])
  const $sizeGuideBtns =
    document.querySelectorAll('.js-size-guide-button') || []
  const $sizeGuideDrawer = document.querySelector('.js-size-guide-drawer') || []

  if ($forms.length) {
    for (const $form of $forms) {
      const $submitButton = $form.querySelector('[type="submit"]')
      const $quantityInput = document.querySelector(
        `nova-quantity-input[data-form-id=${$form.getAttribute('id')}]`,
      )
      $form.addEventListener('submit', (event) => {
        event.preventDefault()

        $submitButton.setAttribute('disabled', true)
        $submitButton.classList.add('loading')

        const formData = new FormData($form)
        const id = formData.get('id')
        const quantity = $quantityInput.value

        addToCart({ id, quantity }).then(() => {
          $submitButton.removeAttribute('disabled')
          $submitButton.classList.remove('loading')
        })
      })
    }

    document.addEventListener('nova:product:render-form', (event) => {
      const content = event.detail.html
      for (const $form of $forms) {
        if (!content) return
        $form.innerHTML = content.innerHTML
      }
    })
  }

  const accordionProductDetails = document.querySelector('.js-accordion-product-details')

  if (accordionProductDetails) {
    document.addEventListener('nova:product:render-accordion-product-details', (event) => {
      const content = event.detail.html
      accordionProductDetails.innerHTML = content.innerHTML
    })
  }

  if ($sizeGuideDrawer) {
    for (const $button of $sizeGuideBtns) {
      $button.addEventListener('click', () => {
        if ($sizeGuideDrawer.hasAttribute('open')) {
          $sizeGuideDrawer.hide()
        } else {
          $sizeGuideDrawer.show()
        }
      })
    }
  }
})
